<template>
    <div v-if="ovt_id">
        <Box  @close="close({})" width="700px">
            <template #top>Registrar Pago | Orden: {{ ovt_id }}</template>
            <template #center>
                <div class="nj-card">
                    <div class="nj-subtitle-1">Datos del pago</div>
                    <div class="nj-cols g12">
                        <div class="nj-cols c3">
                            <InputForm text="Fecha pago">
                                <FechaHora :data="fecha_hora" />
                            </InputForm>
                            <InputForm text="Monto">
                                <input type="text" class="nj-text" v-model="orden_venta_pago.ovp_monto">
                            </InputForm>
                            <InputForm text="Comprobante">
                                <Upload :documnet="document" @input="setDocument($event)"></Upload>
                            </InputForm>
                        </div>
                        <div class="nj-cols">
                            <InputForm text="Descripción">
                                <textarea class="nj-text" rows="4" v-model="orden_venta_pago.ovp_descripcion"></textarea>
                            </InputForm>
                        </div>
                    </div>
                </div>
            </template>
            <template #bottom>
                <Button label="Registrar" icon="add" color="green" @click="registrar()"></Button>
            </template>
        </Box>
    </div>
</template>
<script>

import { OrdenVentaPagoService, ResponseStatus } from "../../rest"
import DateTime from "../../util/dateTime"
import Toast from "../../util/toast"
import { Button, FechaHora, InputForm, Box, Upload } from "../components"


export default {
    name: "RegistrarOrdenVentaPago",
    components: {
        Box,
        InputForm,
        Button,
        FechaHora,
        Upload,
    },
    props: {
        ovt_id: {
            type: Number
        }
    },
    data() {
        return {
            orden_venta_pago: {
                ovt_id: this.ovt_id,
                ovp_fecha_pago: null,
                ovp_registrador: null,
                ovp_descripcion: null,
                ovp_monto: null,
            },
            fecha_hora: null,
            document: null,
        }
    },
    methods: {
        registrar() {
            // capturando la fecha y hora
            this.orden_venta_pago.ovp_fecha_pago = DateTime.convertObjectToString(this.fecha_hora)
            const request = {
                orden_venta_pago: this.orden_venta_pago
            }
            OrdenVentaPagoService
                .registrar(request)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        // Si el documento no es null entonces se procede a adjuntar el documento
                        if (this.document) {
                            const orden = response.data
                            OrdenVentaPagoService
                                .adjuntar(this.document, orden.ovp_id)
                                .then(response => {
                                    if (ResponseStatus.isSuccess(response)) {
                                        Toast.success(response.message)
                                        this.close({
                                            renderizar: true
                                        })
                                    }
                                    else {
                                        Toast.warn(response.message)
                                    }
                                })
                                .catch(error => {
                                    Toast.error(error)
                                    console.error(`error: `, error)
                                })

                        } else {
                            Toast.success(response.message)
                            this.close({
                                renderizar: true
                            })

                        }
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
        },
        setDocument(document) {
            this.document = document
        },
        close({
            componente = "registrarPago",
            status = false,
            renderizar = false
        }) {
            this.$emit("close", {
                componente,
                status,
                renderizar
            })
        }
    },
    mounted() {
        this.fecha_hora = DateTime.splitDateTime(new Date())
    }
}
</script>

<style scoped></style>